import { z } from 'zod';

export const ArticleTagSchema = z.object({
	href: z.string(),
	title: z.string()
});

export const ArticleSchema = z.object({
    title: z.string(),
    schemaDate: z.string(),
    summary: z.string(),
    categoryName: z.string(),
    isVideo: z.boolean(),
    isGallery: z.boolean(),
    url: z.string(),
    image: z.object({
        url: z.string(),
        alt: z.string(),
    }),
    tags: z.array(ArticleTagSchema),
    author: z.string().nullable(),
    primaryTag: z.string(),
    isPremium: z.boolean(),
    videoDuration: z.string().optional(),
    isSignInRequired: z.boolean(),
});

export const NewsListSchema = z.array(ArticleSchema);
